export const BNGM_SCOPE = {
	PRODUCTS: 'products',
	OPTIONS: 'options',
} as const

export type ScopeType = (typeof BNGM_SCOPE)[keyof typeof BNGM_SCOPE]

/** Discriminator persisted in `config.target` for a Promo Combo campaign. */
export const BNGM_TARGET_TYPE = {
	PRODUCTS: 'products',
	OPTION_LIST: 'optionList',
} as const

export interface BuyNGetMRuleState {
	scopeType: ScopeType
	products: Array<{ productKey: string; productSectionKey: string }>
	selectedProductKeys: string[]
	selectedOptionListKey: string | null
	numProductsPaid: number
	numProductsDiscounted: number
	discountPercent: number
}
